export const numericRegex = /^(?:[0-9]|[1-9][0-9]+)(?:\.[0-9]+)?$/;
export const integerRegex = /^(?:[0-9]|[1-9][0-9]+)$/;
export const emailRegex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const phoneRegex = /^\+?[0-9\s]*$/;
